import withIsVisibleHOC from "@client/hocs/withIsVisible";
import { type LabelLink } from "@client/types";
import { getCurrentLink, scrollToLink } from "@client/widgets/DotsMenu/lib";
import classnames from "classnames";
import * as React from "react";

import "./style.less";

export interface DotsMenuProps {
  items: LabelLink[];
}

interface State {
  currentLink: string;
}
class DotsMenu extends React.PureComponent<DotsMenuProps, State> {
  public state: State = {
    currentLink: ""
  };

  public componentDidMount() {
    this._setCurrentLink();
    this._attach();
  }

  public componentWillUnmount(): void {
    this._detach();
  }

  private _onScroll = () => {
    window.requestAnimationFrame(this._setCurrentLink);
  };

  public render() {
    return (
      <div className="dots-menu-container">
        <nav className="dots-menu">
          <ul>
            {this.props.items.map((item, i) => (
              <li key={i} className={classnames({ current: this.state.currentLink === item.link })}>
                <a href={item.link} onClick={this._onItemClick(item.link!)}>
                  <span>{item.label}</span>
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    );
  }

  private _setCurrentLink = () => {
    const activeLink = getCurrentLink(this.props.items);
    if (activeLink !== this.state.currentLink) {
      this.setState({ currentLink: activeLink });
    }
  };

  private _onItemClick(link: string) {
    return (e) => {
      e.preventDefault();

      if (link !== this.state.currentLink) {
        this.setState({ currentLink: link });
      }
      scrollToLink(link);
    };
  }

  private _attach = () => window.addEventListener("scroll", this._onScroll);
  private _detach = () => window.removeEventListener("scroll", this._onScroll);
}
export default withIsVisibleHOC(DotsMenu);
